import React from 'react';

import {
  Modal, ModalContent, ModalOverlay, Image,
} from '@chakra-ui/react';

export default function ZoomImage({ isOpen, onClose, data }: any) {
  if (!data) {
    return null;
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        alignSelf="center"
        alignItems="center">
        <Image
          src={data}
          objectFit="cover"
          width={600}
          height={600}
        />
      </ModalContent>
    </Modal>
  );
}
